import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getReasonCode = async () => {
    // InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "F4_REASONS_FOR_SELECTION";
   inputObj["Input"] = "";
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 }

 export const getCurrencyData = async () => {
   // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_SCAC_CURR";
  inputObj["Input"] = "";
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
}

